import { ColumnDef } from "@tanstack/react-table";
import i18next from "i18next";

export const adherenceTableColumns: ColumnDef<any, string>[] = [
  {
    accessorKey: "name",
    header: () => i18next.t("patientList_columns_name"),
    cell: (info) => info.renderValue(),
    size: 220,
    sortingFn: "text",
  },
  {
    accessorKey: "hospitalPatientId",
    header: () => i18next.t("patientList_columns_hospitalId"),
    cell: (info) => info.renderValue(),
    size: 150,
    sortingFn: "text",
  },
  {
    accessorKey: "id",
    header: () => i18next.t("patientList_columns_pmpId"),
    cell: (info) => info.renderValue(),
    sortingFn: "basic",
  },
  {
    accessorKey: "alerts",
    header: () => i18next.t("patientList_columns_alerts"),
    cell: (info) => info.renderValue(),
    sortingFn: (rowA, rowB) => {
      return rowA.original.alertsCount - rowB.original.alertsCount;
    },
  },
  {
    accessorKey: "signUpDate",
    header: () => i18next.t("patientList_columns_signUpDate"),
    cell: (info) => info.renderValue(),
    size: 160,
    sortingFn: (rowA, rowB) => {
      return (
        rowB.original.signUpDateParsedDate - rowA.original.signUpDateParsedDate
      );
    },
  },
  {
    accessorKey: "lastUsed",
    header: () => i18next.t("patientList_columns_lastUsed"),
    cell: (info) => info.renderValue(),
    size: 170,
    sortingFn: (rowA, rowB) => {
      return rowB.original.lastUsedDate - rowA.original.lastUsedDate;
    },
  },
  {
    accessorKey: "lastReviewedBy",
    header: () => i18next.t("patientList_columns_lastReviewedBy"),
    cell: (info) => info.renderValue(),
    size: 160,
    sortingFn: "text",
  },
  {
    accessorKey: "flag",
    header: () => "",
    cell: (info) => info.renderValue(),
    size: 30,
    enableSorting: false,
  },
  {
    accessorKey: "alertsCount",
    size: 0,
  },
  {
    accessorKey: "lastUsedDate",
    size: 0,
  },
  {
    accessorKey: "signUpDateParsedDate",
    size: 0,
  },
];
